'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eui$002etotp$002e$002dOtp$0024 from "./presto.ui.totp.-Otp$.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_Seed$() {
}
export { $c_Lpresto_ui_Seed$ as $c_Lpresto_ui_Seed$ };
$p = $c_Lpresto_ui_Seed$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_Seed$;
/** @constructor */
function $h_Lpresto_ui_Seed$() {
}
export { $h_Lpresto_ui_Seed$ as $h_Lpresto_ui_Seed$ };
$h_Lpresto_ui_Seed$.prototype = $p;
$p.zw = (function(raw) {
  var x = raw.toUpperCase();
  var len = x.length;
  var sb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_StringBuilder__I__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x$1 = x.charCodeAt(index);
    if ((((x$1 >= 65) && (x$1 <= 90)) || ((x$1 >= 50) && (x$1 <= 55)))) {
      var str = ("" + $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$cToS(x$1));
      sb.K = (sb.K + str);
    }
    i = ((1 + i) | 0);
  }
  return ((len === sb.U()) ? x : sb.K);
});
$p.TL = (function(raw) {
  var n = this.zw(raw);
  if ((n === "")) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("Chave secreta obrigat\u00f3ria");
  } else if ((n.length < 8)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("Chave secreta muito curta");
  } else {
    var x1 = $j_presto$002eui$002etotp$002e$002dOtp$0024.$m_Lpresto_ui_totp_Otp$().ac2(n);
    if ((x1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
    }
    if ((x1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some("Chave secreta inv\u00e1lida \u2014 verifique se \u00e9 um Base32 v\u00e1lido (A-Z e 2-7)");
    }
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x1);
  }
});
var $d_Lpresto_ui_Seed$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_Seed$, "presto.ui.Seed$", ({
  a45: 1
}));
export { $d_Lpresto_ui_Seed$ as $d_Lpresto_ui_Seed$ };
var $n_Lpresto_ui_Seed$;
function $m_Lpresto_ui_Seed$() {
  if ((!$n_Lpresto_ui_Seed$)) {
    $n_Lpresto_ui_Seed$ = new $c_Lpresto_ui_Seed$();
  }
  return $n_Lpresto_ui_Seed$;
}
export { $m_Lpresto_ui_Seed$ as $m_Lpresto_ui_Seed$ };
//# sourceMappingURL=presto.ui.-Seed$.js.map
